<script setup>
import { computed, ref } from 'vue'
import IlluminatedButton from '@/components/buttons/IlluminatedButton.vue'
import { useRuntimeConfig } from '#app';

const config = useRuntimeConfig();

const props = defineProps({
    buttonLabel: String,
    buttonLink: String,
})



const buttonRef = ref(null)

</script>

<template>
  <div ref="buttonRef" class="button-container">
    <IlluminatedButton
        v-if="buttonLabel"
        :label="buttonLabel"
        :link="config.public.wordpressApiUrl+buttonLink"
    />
  </div>
  
</template>

<style lang="scss" scoped>
.button-container{
  margin: 50px auto;
  width: fit-content;
}


</style>